var _rect, _path, _rect2, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDentalTreatment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0003 47.3598C45.5925 47.4512 46.206 62.0005 50.4994 62C53.2174 61.9992 54.9681 58.3396 55.3184 48.9158C55.6691 39.4911 61.5398 37.3862 59.6125 26.4069C57.6846 15.4273 45.2424 21.8886 42.0002 21.8886C38.7575 21.8886 26.315 15.4274 24.3877 26.4069C22.4599 37.3862 28.3301 39.4911 28.6815 48.9158C29.0317 58.3396 30.7833 61.9992 33.5006 62C37.7939 62.0007 38.4076 47.4514 42.0003 47.3598Z",
    fill: "url(#paint0_linear_22660_47129)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#8E8CEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9706 36.75L23.7592 42L21.25 39.4733",
    stroke: "#F4F4F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22660_47129",
    x1: 42,
    y1: 36.275,
    x2: 69.5004,
    y2: 6.13797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#D3D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#BCBBFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDentalTreatment);
export default __webpack_public_path__ + "static/media/icon-dental-treatment.99c1ee246ed565f122936dfd9b0ce15e.svg";
export { ForwardRef as ReactComponent };